/* eslint-disable no-debugger */
import http from 'config/http'
import { PUBLIC_ACCESS } from 'utils/constants'
import {
  MEDIA_REQUESTED,
  GET_MEDIA_FAILED,
  GET_MEDIA_SUCCESS,
  DELETE_MEDIA_FAILED,
  ADD_MEDIA,
  DELETE_MEDIA_SUCCESS,
  UPDATE_MEDIA_SUCCESS,
  UPDATE_MEDIA_FAILED,
  UPLOAD_MASK,
} from '../types/media.type'
import { notifyToast } from 'utils/responseUtils'

export const getFeaturedMediaAction = async (page = 1, tag) => {
  try {
    const response = await fetch(`/api/supabase/fetch-featured-media?page=${page}&tag=${tag}`)
    const payload = await response.json()
    return {
      count: payload.count,
      media: payload?.data?.map((item) => ({
        id: item.id,
        url: item.full_url,
        extra_url: item.extra_url,
        type: 'featured',
        tags: item.tags,
      })),
    }
  } catch (err) {
    console.error(err)
    return []
  }
}

export const getMediaDataAction =
  (type = null, offset = 0, limit = 30) =>
  async (dispatch) => {
    if (type !== 'deployment-result') dispatch({ type: MEDIA_REQUESTED })
    const token = localStorage.getItem('session')
    try {
      const payload = await http
        .get(
          `media/feed?from=${offset}&to=${limit}&${type ? `tags=${type}` : 'excludeTags=mask&excludeTags=deployment-result'}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
          }
        )
        .then((res) => res.data)
      if (type !== 'deployment-result')
        dispatch({
          type: GET_MEDIA_SUCCESS,
          payload:
            payload?.media?.map((item) => ({
              id: item.id,
              url: item.full_url,
              type: 'uploaded',
              tags: item.tags?.join(','),
            })) || [],
        })
      return {
        media:
          payload?.media?.map((item) => ({
            id: item.id,
            url: item.full_url,
            type: type === 'deployment-result' ? 'generated' : 'uploaded',
            tags: item.tags?.join(','),
          })) || [],
        count: payload.total,
      }
    } catch (err) {
      dispatch({ type: GET_MEDIA_FAILED, payload: err?.response?.data })
    }
  }

export const getUnsplashDataAction = async (page = 1, search = null) => {
  try {
    let payload = await http
      .get(
        `https://api.unsplash.com/${
          !search ? 'photos' : 'search/photos'
        }?page=${page}&per_page=30${search ? `&query=${search}` : ''}`,
        {
          headers: {
            Authorization: `Client-ID ${process.env.NEXT_PUBLIC_UNSPLASH_KEY}`,
          },
        }
      )
      .then((res) => res.data)
    if (search) payload = payload.results
    return {
      count: payload.length,
      media: payload.map((item) => ({
        id: item.id,
        url: item.urls.regular,
        type: 'unsplash',
        tags: item.alt_description,
      })),
    }
  } catch (err) {
    console.error(err)
    return []
  }
}

export const deleteMediaAction = (id, callback) => async (dispatch) => {
  try {
    const token = localStorage.getItem('session')
    await http.delete(`media/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    dispatch({ type: DELETE_MEDIA_SUCCESS })
    callback && callback()
  } catch (err) {
    dispatch({ type: DELETE_MEDIA_FAILED, payload: err?.response?.data })
  }
}

export const updateMediaAction = (id, body, selectedIndex) => async (dispatch) => {
  try {
    const token = localStorage.getItem('session')
    await http.put(`media/${id}`, body, {
      headers: { Authorization: `Bearer ${token}` },
    })
    dispatch({
      type: UPDATE_MEDIA_SUCCESS,
      selectedIndex,
      tags: body.tags,
    })
  } catch (err) {
    dispatch({ type: UPDATE_MEDIA_FAILED, payload: err?.response?.data })
  }
}

export const uploadMediaAction =
  (data, loading = true, callback, errorCallback, tags = null) =>
  async (dispatch) => {
    if (loading) dispatch({ type: MEDIA_REQUESTED })
    if (tags?.length) data.append('tags', tags.join())
    const token = localStorage.getItem('session')
    try {
      const payload = await http
        .post(`${process.env.NEXT_PUBLIC_API_URL}uploads/upload`, data, {
          headers: token ? { Authorization: `Bearer ${token}` } : PUBLIC_ACCESS,
        })
        .then((res) => res.data)
      if (tags?.length) {
        dispatch({
          type: tags.length && tags[0] === 'mask' ? UPLOAD_MASK : ADD_MEDIA,
          payload: {
            id: payload?.media?.id,
            url: payload?.media?.url,
            type: 'uploaded',
          },
        })
      }
      callback && callback(payload?.media?.url, payload?.media?.id)
    } catch (err) {
      errorCallback && errorCallback()
      if (err?.code === 'ERR_NETWORK') dispatch(notifyToast('error', 'File size is too large'))

      dispatch({ type: GET_MEDIA_FAILED, payload: 'File is invalid' })
    }
  }

export const getLexicaAIDataAction = async (search = null) => {
  try {
    const payload = await http
      .get(`https://lexica.art/api/v1/search?q=${search ? search : 'photos'}`)
      .then((res) => res.data)

    return {
      count: payload.images.length,
      media: payload.images.map((item) => ({ id: item.id, url: item.src, type: 'lexica', tags: item.prompt })),
    }
  } catch (err) {
    console.error(err)
    return []
  }
}
